<breadcrumb
    [paginas]="[{route:'/home',name:'Home'},{route:'/filtro-visitas-psicologo',name:'Registro Jornada Psicólogo'}]"
  />

  <!-- <app-filtro-padrao class="filtro-jornada" [template]="2" [style]="3" (filtroEmitter)="eventEmittedByFilter($event)"/> -->

 <div class="step-bar-ponto">
   <!-- Barra de Progresso -->
   <step-bar [passoAtual]="passoAtual" [quantidadePassos]="2" (outPasso)="setNovoPasso($event)"></step-bar>
 </div>

    @if(this.passoAtual == 1){
      <app-deslocamento [dadosDeslocamento]="this.modelDeslocamento" (proximoPasso)="proximoPassoDeslocamento($event)"></app-deslocamento>
    }

    @if(this.passoAtual == 2 && modelDeslocamento != null){
      <section class="section-saudacao">
        <div class="container">
          <h6 class="titulo-page">Registrar entrada e saída da escola </h6>
        </div>
      </section>
      <section class="container-conviva form-registro">
        <form action="">
          <div class="container form-vista-psicologo info-psicologo">
            <div class="modal-container">
              <div class="container-localizacao">
                @if(userLogado?.autorizacaoUsoDados == 1){
                  <div  class="localizacao">
                    <p>Localização atual do dispositivo</p>
                    {{latitude}} - {{longitude}} - {{device}}
                  </div>

                  <button
                    class="btn_terciario" (click)="getLocation()">
                    Encontrar Localização
                  </button>
                }
              </div>

              <div class="container-destino-origem">
                <div class="conteudo-colunm">
                  <h2>Origem</h2>
                  <div class="grupo-filter-full">
                    <label>Polo:</label>
                    <p>Polo {{ this.modelDeslocamento.codigoPoloOrigem }}</p>
                  </div>
                  <div class="grupo-filter-full">
                    <label>URE:</label>
                    <p>{{ this.modelDeslocamento.nomeDiretoriaOrigem }}</p>
                  </div>
                  <div class="grupo-filter-full" *ngIf="modelDeslocamento.codigoEscolaOrigem != 0">
                    <label>Escola:</label>
                    <p>{{ this.modelDeslocamento.nomeEscolaOrigem }}</p>
                  </div>
                </div>

                <div class="conteudo-colunm">
                  <h2>Destino</h2>
                  <div class="grupo-filter-full">
                    <label>Polo:</label>
                    <p>Polo {{ this.modelDeslocamento.codigoPoloDestino }}</p>
                  </div>
                  <div class="grupo-filter-full">
                    <label>URE:</label>
                    <p>{{ this.modelDeslocamento.nomeDiretoriaDestino }}</p>
                  </div>
                  <div class="grupo-filter-full" *ngIf="modelDeslocamento.codigoEscolaDestino != 0">
                    <label>Escola:</label>
                    <p>{{ this.modelDeslocamento.nomeEscolaDestino }}</p>
                  </div>
                </div>
              </div>
            <br />

              <!-- Corpo do Modal -->
              <div class="modal-body">
                <p class="descricao-modal"> Para garantir o registro correto de sua entrada na escola, precisamos de algumas informações importantes. </p>
                <div class="row-escola">
                  <img src="../../../assets/img/icons/icon-nome-escola.svg" title="Diretoria de Ensino" alt="">
                  <p>
                    <b>URE:</b> {{ this.modelDeslocamento.nomeDiretoriaDestino }}
                  </p>
                </div>
                <div class="row-escola" *ngIf="modelDeslocamento.codigoEscolaDestino != 0">
                  <img src="../../../assets/img/icons/icon-nome-escola.svg" title="Escala" alt="">
                  <p>
                    <b>Escola </b> {{ this.modelDeslocamento.nomeEscolaDestino }}
                  </p>
                </div>


                @if(userLogado?.autorizacaoUsoDados != 1){
                  <div class="validacao-autorizacao">
                    <p>
                      ⚠️ <b>Atenção:</b> é necessário autorizar o uso dos seus dados para continuar.
                      <a href="/termos-de-uso-de-dados" target="_blank" rel="noopener noreferrer">Autorizar Dados</a>
                    </p>
                  </div>
                }

                @if(validaConexaoUsuario){
                  <div class="validacao-autorizacao">
                    <p>
                      <b>
                        ⚠️ Detectamos que você não permitiu o acesso a sua localização. Motivo da ausência de localização:
                      </b>
                    </p>
                    <div class="motivo-ausencia">
                      <select id="motivo" [(ngModel)]="motivoSelecionado">
                        <option value="" disabled selected>Selecione um motivo de ausência de conexão</option>
                        <option value="Navegador não suporta">Navegador não suporta</option>
                        <option value="Não notei">Não notei</option>
                        <option value="Outros">Outros</option>
                      </select>

                      <input *ngIf="motivoSelecionado === 'Outros'"
                        type="text"
                        [(ngModel)]="motivoOutro"
                        placeholder="Digite o motivo">
                    </div>
                  </div>
                }

              </div>

              <!-- Footer do Modal -->
              <div class="modal-footer">

                @if(infoRegistroPontoSucesso || JornadaAtiva){
                  <div class="registro_ponto_sucesso" >
                    <!-- <h2>Horário Registro de Entrada: 09:30</h2> -->
                    <h2>{{mensagemRetornoSucesso}}</h2>
                    <button class="btn_primeiro" (click)="redirectToHome()">
                      OK
                    </button>
                  </div>
                }


                @if(!infoRegistroPontoSucesso && !JornadaAtiva){
                  <button class="btn_registrar" (click)="RegistrarInicioJornada()" [disabled]="submmited || showModalJornadaEmAberto">
                    Registrar Entrada na Escola
                  </button>

                }
              </div>
            </div>
          </div>
        </form>
        
        <app-modal class="modal-overlay" *ngIf="showModalJornadaEmAberto">
          <div class="modal-container">
            <div class="modal-header">
              <div class="titulo-modal">
                <h2>Jornada em aberto</h2>
              </div>
              <button class="btn-fechar-modal" (click)="fecharModalJornadaEmAberto()">✖</button>
            </div>

            <div class="modal-body">
              <p class="descricao-modal">
                Existe uma jornada anterior sem registro de checkout. Para prosseguir, informe o horário de encerramento da jornada pendente.
              </p>

              @if (jornadaEmAbertoParaFechar; as j) {
                <dl class="jornada-em-aberto-resumo">
                  <div class="jornada-em-aberto-resumo__linha">
                    <dt>Data do check-in</dt>
                    <dd>{{ jornadaAbertoResumo.dataCheckIn(j) }}</dd>
                  </div>
                  <div class="jornada-em-aberto-resumo__linha">
                    <dt>Hora do check-in</dt>
                    <dd>{{ jornadaAbertoResumo.horaCheckIn(j) }}</dd>
                  </div>
                  <div class="jornada-em-aberto-resumo__linha">
                    <dt>Código da jornada</dt>
                    <dd>{{ j.codigoJornada }}</dd>
                  </div>
                  <div class="jornada-em-aberto-resumo__linha">
                    <dt>URE</dt>
                    <dd>{{ jornadaAbertoResumo.ure(j) }}</dd>
                  </div>
                  @if (jornadaAbertoResumo.escola(j); as textoEscola) {
                    <div class="jornada-em-aberto-resumo__linha">
                      <dt>Escola</dt>
                      <dd>{{ textoEscola }}</dd>
                    </div>
                  }
                </dl>
              }

              <div class="conteudo-select">
                <label for="horaEncerramentoJornadaEmAberto">Horário de encerramento (HH:mm)</label>
                <input
                  type="time"
                  id="horaEncerramentoJornadaEmAberto"
                  name="horaEncerramentoJornadaEmAberto"
                  class="input-time"
                  [(ngModel)]="horaEncerramentoJornadaEmAberto"
                />

                @if(submittedHoraEncerramentoJornadaEmAberto && !horaEncerramentoJornadaEmAberto){
                  <div class="alert">Horário de encerramento é obrigatório.</div>
                }
                @if(erroHoraEncerramentoJornadaEmAberto){
                  <div class="alert">{{ erroHoraEncerramentoJornadaEmAberto }}</div>
                }
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn_outline" (click)="fecharModalJornadaEmAberto()">Cancelar</button>
              <button class="btn_primeiro" (click)="confirmarEncerramentoJornadaEmAberto()">Confirmar</button>
            </div>
          </div>
        </app-modal>
    </section>

    }
